import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Radio,
  TextField,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  CircularProgress,
} from "@mui/material";
import CustomDatePicker from "../Components/DatePicker";
import {
  startAirDropHandler,
  getTotalAllocation,
  checkAllowance,
  approveToken,
} from "../ContractAction/AirDropContractAction";
import { getProvider } from "../ContractAction/ContractDependency";
import toast from "react-hot-toast";
import { ethers } from "ethers";

const MuiDialog = ({
  timeOpen,
  handleClose,
  addr,
  tokenDetails,
  tokenAddress,
  bal,
  setUpdate,
  update,
}) => {
  const [selectedOption, setSelectedOption] = useState("start_now");
  const [lockUntil, setLockUntil] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tokenAllowance, setTokenAllowance] = useState(false);

  const handleRadioChange = (event) => setSelectedOption(event.target.value);
  console.log(
    "balance value:",
    bal,
    "type:",
    typeof bal,
    "parseFloat:",
    parseFloat(bal),
    "comparison:",
    parseFloat(bal) > 0
  );
  useEffect(() => {
    if (parseFloat(bal) > 0 && tokenAddress) {
      checkAllowance(tokenAddress, bal, addr)
        .then(setTokenAllowance)
        .catch((error) => console.error("Error checking allowance:", error));
    }
  }, [bal, tokenAddress]);

  const timeHandler = async () => {
    try {
      setLoading(true);
      if (!tokenAllowance) {
        const txHash = await approveToken(tokenAddress, bal, addr);
        if (txHash) {
          toast.success("Approved! ✅");
          const updatedAllowance = await checkAllowance(
            tokenAddress,
            bal,
            addr
          );
          setTokenAllowance(updatedAllowance);
        } else {
          toast.error("Approval failed ❌");
          return;
        }
      } else {
        let timeInMillis;
        if (selectedOption === "start_now") {
          // Get provider inside async function with proper error handling
          const provider = await getProvider();
          if (!provider) {
            toast.error("Please connect your wallet ❌");
            return;
          }

          const currentBlock = await provider.getBlock("latest");
          timeInMillis = currentBlock.timestamp + 20;
          console.log("timeInMillis1234", timeInMillis);
        } else {
          if (!lockUntil) {
            toast.error("Please select a valid lock time! ❌");
            return;
          }
          const tgeDateTime = new Date(lockUntil);
          timeInMillis = Math.floor(tgeDateTime.getTime() / 1000); // e.g., 1748586202
          console.log("timeInMillis1234", timeInMillis);
        }
        const tx = await startAirDropHandler(
          timeInMillis,
          addr,
          bal,
          tokenAddress
        );
        if (tx) {
          toast.success("Airdrop started successfully! 🚀");
          setUpdate((prev) => !prev);
          handleClose();
        }
      }
    } catch (error) {
      console.error("Error in timeHandler:", error);
      toast.error(`Error: ${error.message || "Something went wrong"} ❌`);
    } finally {
      setLoading(false);
    }
  };
  console.log("tokenAllowance", tokenAllowance);
  return (
    <Dialog
      open={timeOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          backgroundColor: "#242525", // Dark background
          color: "white",
          maxWidth: "600px",
          width: "100%",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
        Setting Time To Start
      </DialogTitle>

      <DialogContent>
        <Box>
          <FormControl>
            <FormLabel id="airdrop-time-label">
              <Typography variant="body1" sx={{ color: "#B0B0B0", mb: 1 }}>
                Setting time to start airdrop
              </Typography>
            </FormLabel>
            <RadioGroup
              aria-labelledby="airdrop-time-label"
              value={selectedOption}
              onChange={handleRadioChange}
              name="airdrop-time-options"
            >
              <FormControlLabel
                value="start_later"
                control={
                  <Radio
                    sx={{
                      color: "#60A5FA",
                      "&.Mui-checked": { color: "#60A5FA" },
                    }}
                  />
                }
                label="Start after specific time"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        {selectedOption === "start_later" && (
          <Box mt={2}>
            <Typography variant="body2" sx={{ color: "#B0B0B0", mb: 1 }}>
              Lock Until (UTC time)*
            </Typography>
            <Box
              sx={{
                "& .MuiInputBase-root": {
                  color: "white",
                  backgroundColor: "#2B2C2C",
                  borderRadius: "8px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#374151",
                },
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
              }}
            >
              <CustomDatePicker value={lockUntil} onChange={setLockUntil} />
            </Box>
          </Box>
        )}

        <Box
          mt={3}
          sx={{
            border: "1px solid #E5B649",
            backgroundColor: "rgba(229, 182, 73, 0.1)",
            textAlign: "center",
            padding: "12px",
            borderRadius: "8px",
          }}
        >
          <Typography variant="body2" sx={{ color: "#E5B649" }}>
            You need at least {bal} {tokenDetails?.symbol} to start airdrop.
            Your balance: {tokenDetails?.balance || 0} {tokenDetails?.symbol}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: "0 24px 24px" }}>
        <Button
          onClick={handleClose}
          sx={{
            color: "#9CA3AF",
            "&:hover": { color: "white" },
          }}
        >
          CANCEL
        </Button>
        {parseFloat(bal) > 0 ? (
          <Button
            onClick={timeHandler}
            variant="contained"
            disabled={loading}
            sx={{
              backgroundColor: "#93C5FD",
              color: "#1F2937",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#60A5FA" },
            }}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ color: "#1F2937", mr: 1 }} />
                Submitting...
              </>
            ) : tokenAllowance ? (
              "START AIRDROP"
            ) : (
              "APPROVE"
            )}
          </Button>
        ) : (
          <Typography color="error" variant="caption">
            {parseFloat(bal) === 0
              ? "No tokens allocated"
              : "Insufficient balance"}
          </Typography>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MuiDialog;
